import { mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import propertyPop from '@/dpp/components/propertypop/property-pop.vue';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';

var timer;
var axieX = null;
var axieY = null;
var distance = null;
var currentX = null;
var currentY = null;
var nextX = null;
var nextY = null;
var currentZoom = null;
var isPressing = false;
var disableX = false;
var disableY = false;
var tapCount = 0;
var doubleTimer = null;
var scrollTimer = null;
var imgHeight = 0;
var imgWidth = 0;
var animationTime = 250;
var timer2 = null;

export default {
    name: 'propertyPopPhotoSingleNew',
    inject: ['$eventBus'],
    components: {
        propertyPop,
        mvtMapStatic,
        mvtHotleadForm,
    },
    data() {
        //todo remove the useless fields
        return {
            imageIndex: -1,
            cateIndex: null,
            photoIndex: null,
            galleryData: [],
            galleryIndex: 0,
            loadGallery: false,
            active: false,
            backgroundPosition: '50% 50%',
            zomming: false,
            maxX: 0,
            maxY: 0,
            trigger: '',
            scrollIndex: 0,
            zoomLevel: 3,
            moving: false,
            imgRatio: 0,
            minZoomIn: 1.1,
            mode: '',
            isGridView: false,
            width: 0,
            height: 0,
        };
    },
    props: ['popPhotoCateIndex', 'popPhotoIndex'],
    computed: {
        ...mapGetters('glb', ['glb', 'viewport', 'getSplit', 'hasAgent', 'removeAds']),
        ...mapGetters('dpp', ['dpp', 'getCategories', 'getPhotos', 'getMapUrls', 'getCateIndex', 'getPhotoIndex']),

        prepareHotleadForm() {
            return (this.imageIndex >= this.photoList.length - 1 && this.active && this.isListView) || (!this.isListView && !this.getCurrentPhoto);
        },
        isEnd() {
            if (this.isGridView) {
                return this.formVisible;
            }
            if (this.scrollIndex >= this.photoList.length - 1) {
                return true;
            }
            return false;
        },
        isZoomIn() {
            return this.zoomLevel !== 1;
        },
        gethotleadSub() {
            if (!this.dpp.isActive) {
                let area = this.dpp.geo.neighborhoodName || this.dpp.geo.zipcode;
                return `Our agents specialize in selling homes in ${area}`;
            }
            return '';
        },
        hotleadOpt() {
            return {
                hotleadTitle: !this.dpp.isActive ? 'Connect with a local selling agent' : undefined,
                hotleadType: !this.dpp.isActive ? 'OffMarketCombinationSell' : 'All_Photos_Bottom_Active',
                hotleadSub: this.gethotleadSub,
                propertyId: this.dpp.propertyId,
                hideProfile: true,
                propertyData: this.dpp,
                showComment: false,
                buttonText: !this.dpp.isActive ? 'Connect' : undefined,
            };
        },
        photoList() {
            let photos = this.getPhotos || [];
            if (this.getMapUrls && this.getMapUrls.length > 0) {
                photos = photos.concat(this.getMapUrls);
            }
            return photos;
        },
        hasCategories() {
            return this.getCategories.length > 1;
        },
        showPhotoCategories() {
            return !(this.dpp.mlsDbNumber === 663 && this.dpp.houseRealStatus === 'PENDING') && this.hasCategories;
        },
        getPrevPhoto() {
            if (this.imageIndex === 0) {
                return null;
            }
            return this.photoList[this.imageIndex - 1] || null;
        },
        showHotleadForm() {
            return !this.getCurrentPhoto && this.active;
        },
        getNextPhoto() {
            if (this.imageIndex === this.photoList.length) {
                return null;
            }
            return this.photoList[this.imageIndex + 1] || null;
        },
        getCurrentPhoto() {
            return this.photoList[this.imageIndex] || null;
        },
        getPopPhotoIndex() {
            return this.popPhotoIndex;
        },
        fitHeight() {
            return this.imgRatio < this.winRatio;
        },
        winRatio() {
            return this.width / this.height;
        },
        coreStyle() {
            if (!this.getCurrentPhoto || !this.active) {
                return {
                    backgroundImage: 'none',
                    backgroundSize: '100%',
                    backgroundPosition: '50% 50%',
                };
            }
            return {
                backgroundImage: `url('${this.getCurrentPhoto.src_l ? this.getCurrentPhoto.src_l : this.getCurrentPhoto.path + this.getCurrentPhoto._l}')`,
                backgroundSize: this.fitHeight ? `auto ${this.zoomLevel * 100}%` : ` ${this.zoomLevel * 100}% auto`,
                backgroundPosition: this.backgroundPosition,
            };
        },
        isFirst() {
            return this.imageIndex === 0;
        },
        isLast() {
            return this.imageIndex === this.photoList.length;
        },
        isLastPhoto() {
            return this.imageIndex === this.photoList.length - 1;
        },
        isListView() {
            if (this.width <= this.viewport.smScreen[1]) {
                return true;
            }
            return false;
        },
    },
    watch: {
        getCurrentPhoto(newVal, oldVal) {
            if (newVal && newVal.cateIndex >= 0) {
                if (scrollTimer) {
                    clearTimeout(scrollTimer);
                }
                scrollTimer = setTimeout(() => {
                    this._updateList(newVal.i);
                }, 10);
            }
        },
    },

    methods: {
        ...mapMutations('dpp', ['updateCateIndex', 'updatePhotoIndex', 'updateImageIndex', 'getPhotos']),
        ...mapGetters('glb', ['getComplianceMethod']),
        showWatermark() {
            const compliance = this.getComplianceMethod()();
            return compliance[0]?.rule.indexOf('showMlsWatermarkOnViewArea') >= 0;
        },
        toggleView() {
            this.isGridView = !this.isGridView;
        },
        beforeHide() {
            if (this.glb.isPhone) {
                if (this.cateIndex >= 0) {
                    let item = this.getPhotos.find((e) => {
                        return e.cateIndex === this.cateIndex && e.index === 0;
                    });
                    item && this.updateImageIndex(item.i);
                }
            } else {
                if (this.cateIndex >= 0) {
                    this.updateCateIndex(this.cateIndex);
                }
                if (this.photoIndex >= 0) {
                    this.updatePhotoIndex(this.photoIndex);
                }
                if (this.imageIndex >= 0) {
                    this.updateImageIndex(this.imageIndex);
                }
            }
        },
        onImgLoad(e) {
            imgHeight = e.target.naturalHeight;
            imgWidth = e.target.naturalWidth;
            this.imgRatio = imgWidth / imgHeight;
        },
        _updateActiveItem($activeItem) {
            var cateIndex = $activeItem.getAttribute('data-cateIndex');
            if (cateIndex === null) {
                cateIndex = -1;
            } else {
                cateIndex = cateIndex * 1;
            }
            if (cateIndex >= 0 && this.cateIndex !== cateIndex) {
                this.cateIndex = cateIndex;
                if (this.trigger !== 'nav') {
                    this._updateNav(cateIndex);
                }
            }
            this.scrollIndex = $activeItem.getAttribute('data-index') * 1;
        },
        _updateIndex() {
            var items = this.$refs.thumbnail.querySelectorAll('li');
            for (let i = 0; i < items.length; i++) {
                var item = items[i];
                var top = item.getBoundingClientRect().top;
                if (Math.ceil(top) >= 0) {
                    if (i !== this.scrollIndex) {
                        this._updateActiveItem(item);
                    }
                    break;
                }
            }
        },
        onClickPhoto(i) {
            this.updateIndex(i);
            this.zoomIn();
        },
        onScroll() {
            if (timer2) {
                clearTimeout(timer2);
            }
            timer2 = setTimeout(() => {
                this._updateIndex();
            }, 200);
        },
        doubleTap() {
            if (this.zoomLevel === 1) {
                this.presetZoomIn();
            } else {
                this.resetZoomOut();
            }
        },
        resetPrevNext() {
            var container = this.$refs.container;
            container.style.setProperty('--pull-over-right-opacity', '0');
            container.style.setProperty('--pull-over-right', '0%');
            container.style.setProperty('--pull-over-left-opacity', '0');
            container.style.setProperty('--pull-over-left', '0%');
            container.style.removeProperty('--current-opactiy');
            this.zoomMove(50, 50);
            if (this.$refs.prevPhoto) {
                this.$refs.prevPhoto.src = this.getPrevPhoto.src_l ? this.getPrevPhoto.src_l : this.getPrevPhoto.path + this.getPrevPhoto._l;
            }
            if (this.$refs.nextPhoto) {
                this.$refs.nextPhoto.src = this.getNextPhoto.src_l ? this.getNextPhoto.src_l : this.getNextPhoto.path + this.getNextPhoto._l;
            }
        },
        presetZoomIn() {
            if (this.fitHeight) {
                this.zoomLevel = (imgHeight * this.width) / (imgWidth * this.height);
            } else {
                this.zoomLevel = (imgWidth * this.height) / (imgHeight * this.width);
            }

            currentX = nextX = 50;
            currentY = nextY = 50;
            currentZoom = this.zoomLevel;
            this.zoomMove(currentX, currentY);
        },
        resetZoomOut() {
            this.zoomLevel = 1;
            currentX = nextX = 50;
            currentY = nextY = 50;
            this.zoomMove(currentX, currentY);
        },
        touchStart(e) {
            e.cancelable && e.preventDefault();
            if (!this.isListView) {
                return;
            }
            if (!this.isZoomIn) {
                this.resetPrevNext();
            }
            this.moving = false;
            isPressing = true;
            if (e.touches && e.touches.length === 1) {
                axieX = e.touches[0].clientX;
                axieY = e.touches[0].clientY;
                tapCount++;
                if (doubleTimer) {
                    clearTimeout(doubleTimer);
                }
                if (tapCount > 1) {
                    tapCount = 0;
                    this.doubleTap();
                } else {
                    doubleTimer = setTimeout(() => {
                        tapCount = 0;
                    }, animationTime);
                }
            } else if (e.touches && e.touches.length === 2) {
                distance = Math.sqrt(Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) + Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2));
            }
        },
        touchEnd(e) {

            e.cancelable && e.preventDefault();
            disableX = false;
            disableY = false;
            if (this.zoomLevel < this.minZoomIn && this.isZoomIn) {
                this.resetZoomOut();
            }
            if (e.touches.length === 0) {
                axieX = null;
                axieY = null;
                isPressing = false;
            }
            if (!this.mode) {
                return;
            }
            if (e.touches.length === 0) {
                currentZoom = this.zoomLevel;
                currentX = nextX;
                currentY = nextY;
            }

            var containter = this.$refs.container;
            if (this.mode === 'pullOverLeft' && this.isFirst) {
                this.mode = 'pullBackLeft';
            } else if (this.mode === 'pullOverRight' && this.isLast) {
                this.mode = 'pullBackRight';
            }
            if (!this.isListView) {
                return;
            }

            if (this.mode === 'pullOverTop') {
                this.moving = true;
                this.zoomMove('50%', `-${this.height}px`, true);
                setTimeout(() => {
                    this.moving = false;
                    this.mode = null;
                    this.zoomOut();
                }, animationTime);
            } else if (this.mode === 'pullOverBottom') {
                this.moving = true;
                this.zoomMove('50%', `${this.height}px`, true);
                setTimeout(() => {
                    this.moving = false;
                    this.mode = null;
                    this.zoomOut();
                }, animationTime);
            } else if (this.mode === 'pullBackTop' || this.mode === 'pullBackBottom') {
                this.moving = true;
                this.zoomMove('50%', '50%', true);
                setTimeout(() => {
                    this.moving = false;
                    this.mode = null;
                }, animationTime);
            } else if (this.mode === 'pullOverLeft') {
                this.moving = true;
                containter.style.setProperty('--pull-over-left-opacity', '1');
                containter.style.setProperty('--pull-over-left', '100%');
                containter.style.setProperty('--pull-over-right-opacity', '0');
                containter.style.setProperty('--pull-over-right', '0');
                this.zoomMove(`${this.width}px`, '50%', true);
                setTimeout(() => {
                    containter.style.setProperty('--current-opactiy', 0);
                    this._prev();
                    this.moving = false;
                    currentX = 50;
                    currentY = 50;
                    this.mode = null;
                }, animationTime);
            } else if (this.mode === 'pullOverRight') {
                this.moving = true;
                containter.style.setProperty('--pull-over-right-opacity', '1');
                containter.style.setProperty('--pull-over-right', '-100%');
                containter.style.setProperty('--pull-over-left-opacity', '0');
                containter.style.setProperty('--pull-over-left', '0');
                this.zoomMove(`-${this.width}px`, '50%', true);
                setTimeout(() => {
                    containter.style.setProperty('--current-opactiy', 0);
                    this._next();
                    if (this.isLastPhoto) {
                        containter.style.setProperty('--pull-over-right', '0%');
                        this.zoomMove(50, 50);
                    }
                    this.moving = false;
                    currentX = 50;
                    currentY = 50;
                    this.mode = null;
                }, animationTime);
            } else if (this.mode === 'pullBackLeft') {
                this.moving = true;
                containter.style.setProperty('--pull-over-right-opacity', '0');
                containter.style.setProperty('--pull-over-right', '0');
                containter.style.setProperty('--pull-over-left', '0');
                containter.style.removeProperty('--current-opactiy');
                this.zoomMove(50, 50);
                setTimeout(() => {
                    containter.style.setProperty('--pull-over-left-opacity', '0');
                    this.moving = false;
                    this.mode = null;
                }, animationTime);
            } else if (this.mode === 'pullBackRight') {
                this.moving = true;
                containter.style.setProperty('--pull-over-left-opacity', '0');
                containter.style.setProperty('--pull-over-left', '0');
                containter.style.setProperty('--pull-over-right', '0');
                containter.style.removeProperty('--current-opactiy');
                this.zoomMove(50, 50);
                setTimeout(() => {
                    containter.style.setProperty('--pull-over-right-opacity', '0');
                    this.moving = false;
                    this.mode = null;
                }, animationTime);
            }
        },
        touchMove(e) {
            e.cancelable && e.preventDefault();
            if (isPressing) {
                let zoomer = e.currentTarget;
                if (!this.isListView) {
                    return;
                }

                if (e.touches && e.touches.length === 2) {
                    //moving mode
                    var deltaD = Math.sqrt(Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) + Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2)) - distance;
                    this.zoomLevel = Math.max(0.5, currentZoom + deltaD * 0.01);
                    if (deltaD < 0) {
                        if (nextX > 50) {
                            nextX = Math.max(50, nextX + deltaD * 0.005);
                        } else {
                            nextX = Math.min(50, nextX - deltaD * 0.005);
                        }
                        if (nextY > 50) {
                            nextY = Math.max(50, nextY + deltaD * 0.005);
                        } else {
                            nextY = Math.min(50, nextY - deltaD * 0.005);
                        }
                    } else if (!this.active) {
                        this.zoomIn();
                    }
                    this.mode = 'pinch';
                    this.zoomMove(nextX, nextY);
                } else if (e.touches && e.touches.length === 1) {
                    //swipe mode
                    var deltaX = disableX ? 0 : ((axieX - e.touches[0].clientX) / zoomer.offsetWidth) * 100;
                    var deltaY = disableY ? 0 : ((axieY - e.touches[0].clientY) / zoomer.offsetHeight) * 100;
                    nextX = currentX + deltaX;
                    nextY = currentY + deltaY;
                    if (!this.isZoomIn) {
                        var container = this.$refs.container;
                        if (Math.abs(deltaY) > Math.abs(deltaX)) {
                            disableX = true;
                            disableY = false;
                            if (deltaY > 0 && deltaY < 50) {
                                var top = 50 - deltaY;
                                this.zoomMove('50%', top + '%', true);
                                if (deltaY > 15) {
                                    this.mode = 'pullOverTop';
                                } else {
                                    this.mode = 'pullBackTop';
                                }
                            } else if (deltaY < 0 && deltaY > -50) {
                                var bottom = 50 - deltaY;
                                this.zoomMove('50%', bottom + '%', true);
                                if (deltaY < -15) {
                                    this.mode = 'pullOverBottom';
                                } else {
                                    this.mode = 'pullBackBottom';
                                }
                            }
                            return;
                        }
                        disableX = false;
                        disableY = true;
                        if (deltaX < 0 && nextX > -50 && !this.isFirst) {
                            var leftOpacity = deltaX * -0.05;
                            var left = Math.min(deltaX * -2, 100);
                            container.style.setProperty('--pull-over-right-opacity', '0');
                            container.style.setProperty('--pull-over-right', '0');
                            container.style.setProperty('--pull-over-left-opacity', leftOpacity);
                            container.style.setProperty('--pull-over-left', `${left}%`);
                            container.style.setProperty('--current-opactiy', Math.max(1 - leftOpacity, 0.2));
                            this.zoomMove(Math.floor(((1 - left) / -100) * this.width) + 'px', '50%', true);
                            if (deltaX < -15) {
                                this.mode = 'pullOverLeft';
                            } else {
                                this.mode = 'pullBackLeft';
                            }
                        } else if (deltaX > 0 && deltaX < 50 && !this.isLast) {
                            var rightOpacity = deltaX * 0.05;
                            var right = Math.max(deltaX * -2, -100);
                            container.style.setProperty('--pull-over-left-opacity', '0');
                            container.style.setProperty('--pull-over-left', '0');
                            container.style.setProperty('--pull-over-right-opacity', rightOpacity);
                            container.style.setProperty('--pull-over-right', `${right}%`);
                            container.style.setProperty('--current-opactiy', Math.max(1 - rightOpacity, 0.2));
                            this.zoomMove(Math.floor(((1 - right) / -100) * this.width) + 'px', '50%', true);
                            if (deltaX > 15) {
                                this.mode = 'pullOverRight';
                            } else {
                                this.mode = 'pullBackRight';
                            }
                        }
                    } else {
                        //drag
                        this.mode = 'drag';
                        if (nextY < this.maxY * -1) {
                            nextY = this.maxY * -1;
                        }
                        if (nextY > 100 + this.maxY) {
                            nextY = 100 + this.maxY;
                        }
                        if (nextX < this.maxX * -1) {
                            nextX = this.maxX * -1;
                        }
                        if (nextX > 100 + this.maxX) {
                            nextX = 100 + this.maxX;
                        }
                        this.zoomMove(nextX, nextY);
                    }
                }
            }
        },
        zoomIn(e) {
            this.active = true;
            this.zoomLevel = 1;
            currentZoom = this.zoomLevel;
            currentX = 50;
            currentY = 50;
            if (e) {
                setTimeout(() => {
                    this.mouseMove(e);
                });
            } else {
                this.zoomMove(currentX, currentY);
            }
        },
        zoomMove(x, y, unit) {
            if (unit) {
                this.backgroundPosition = `${x} ${y}`;
            } else {
                this.backgroundPosition = `${x}% ${y}%`;
            }
        },
        zoomOut() {
            this.active = false;
            this.resetPrevNext();
        },
        onClickImg(e) {
            if (this.zoomLevel < this.minZoomIn) {
                this.zoomLevel = 4;
            } else {
                this.zoomLevel = 1;
                this.toggleZoom(e);
            }
        },
        toggleZoom(e) {
            if (this.active) {
                this.zoomOut();
            } else {
                this.zoomIn(e);
            }
        },
        mouseMove(e) {
            if (this.zoomLevel < this.minZoomIn) {
                return;
            }
            let x, y;
            let $imgRoot = this.$refs.figure;
            let clientX = null;
            let clientY = null;
            if (e.offsetX) {
                clientX = e.offsetX;
                clientY = e.offsetY;
            }
            if (clientX !== null && clientY !== null) {
                x = (clientX / $imgRoot.offsetWidth) * 100;
                y = (clientY / $imgRoot.offsetHeight) * 100;
                this.zoomMove(x, y);
            }
        },
        mouseLeave(e) {
            this.zoomOut();
        },
        updateIndex(index) {
            this.imageIndex = index;
        },
        updateById(cateIndex, photoIndex) {
            this.cateIndex = cateIndex;
            this.photoIndex = photoIndex;
            var nextPhoto = this.photoList.find((photo) => photo.cateIndex == cateIndex && photo.index == photoIndex);
            this.imageIndex = nextPhoto.i;
            this._updateNav(cateIndex);
        },
        _prev() {
            if (this.imageIndex >= 1) {
                this.updateIndex(this.imageIndex - 1);
            }
        },
        _next() {
            if (this.imageIndex < this.photoList.length) {
                this.updateIndex(this.imageIndex + 1);
            }
        },
        _updateList(index) {
            var list = this.$refs.thumbnail;
            var activeItems = list.querySelectorAll('li.active');
            activeItems.forEach((item) => item.classList.remove('active'));
            var activeItem = list.querySelector(`[data-index="${index}"]`);

            if (activeItem) {
                activeItem.classList.add('active');
                //check if activeItem is in the view
                let rect = activeItem.getBoundingClientRect();
                let listRect = list.getBoundingClientRect();
                let top = rect.top;
                let bottom = rect.bottom;
                let viewTop = listRect.top;
                let viewBottom = listRect.bottom;
                if (top < viewTop || bottom > viewBottom) {
                    activeItem.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
                }
            }
        },
        _updateNav(index) {
            this.trigger = 'nav';
            var nav = this.$refs.photoNav;
            var current = this.$el.querySelector(`[data-nav="${index}"]`);
            if (!current) {
                return;
            }
            var activeItems = nav.querySelectorAll('.active');
            activeItems.forEach((item) => item.classList.remove('active'));
            current.classList.add('active');
            if (timer) {
                clearTimeout(timer);
            }
            //only scroll if needed
            current.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
            timer = setTimeout(() => {
                this.trigger = '';
            }, 1000);
        },
        open: function (cateIndex, photoIndex, isSingle) {
            if (cateIndex !== -1) {
                this.updateById(cateIndex, photoIndex);
                setTimeout(() => {
                    if (photoIndex === 0 && cateIndex === 0) {
                        this._updateList(photoIndex);
                    }
                }, 200);
            } else {
                this.updateIndex(photoIndex);
            }
            this.$refs.pop.open();
        },
        close() {
            this.zoomOut();
            this.$refs.pop.close();
        },
        setSize() {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        },
    },
    created() {
        this.setSize();
    },
    mounted() {
        $(document).on('dom.key.left.' + this.vnumber, this._prev);
        $(document).on('dom.key.right.' + this.vnumber, this._next);
        $(document).on('dom.resize.' + this.vnumber, this.setSize);
    },
    beforeUnmount() {
        $(document).off('dom.key.left.' + this.vnumber);
        $(document).off('dom.key.right.' + this.vnumber);
        $(document).off('dom.resize.' + this.vnumber);
    },
};
